var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.998 24.5703H2.02309C0.907389 24.5703 0 23.7638 0 22.7732V1.79791C0 0.806537 0.907692 0 2.02309 0H33.998C35.1137 0 36.0211 0.807075 36.0211 1.79791V22.7732C36.0214 23.7641 35.1134 24.5706 33.9977 24.5706L33.998 24.5703ZM2.02309 0.719028C1.35384 0.719028 0.80898 1.20263 0.80898 1.79784V22.7732C0.80898 23.3678 1.35383 23.8515 2.02309 23.8515H33.998C34.667 23.8515 35.2122 23.3678 35.2122 22.7732L35.2119 1.79784C35.2119 1.20265 34.6667 0.719028 33.9977 0.719028H2.02309Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7069 20.8985V16.7406L23.835 15.4844L15.8397 19.06L8.53266 18.3542L3.0791 20.8985",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5413 7.93747L31.2311 4.65883C31.1673 4.56667 31.0999 4.47662 31.0296 4.38867L27.2488 7.7479L27.5413 7.93747Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9157 7.53215L30.7825 4.0957C30.7072 4.01325 30.6295 3.93397 30.5482 3.85547L26.624 7.3426L26.9157 7.53215Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 6.1289L29.6766 3.15742C29.5796 3.09388 29.4795 3.03218 29.3778 2.97363L26.3321 5.67997L26.3324 6.12892L26.3318 6.1289Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 5.16791L29.0183 2.78163C28.908 2.72781 28.7972 2.67766 28.6832 2.62988L26.3318 4.71922L26.3318 5.16791Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 4.20591L28.2808 2.47414C28.1578 2.43187 28.0326 2.39433 27.9055 2.35889L26.3318 3.75722L26.3318 4.20591Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 3.24414L27.4517 2.24907C27.3119 2.22072 27.1695 2.19814 27.0265 2.17871L26.3318 2.79595L26.3318 3.24414Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3318 7.09018L30.2636 3.59626C30.1773 3.52275 30.0896 3.45134 29.9986 3.38281L26.332 6.64122L26.3318 7.09018Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1676 8.34324L31.6051 5.28882C31.554 5.18616 31.4993 5.08482 31.4408 4.98584L27.875 8.15425L28.1676 8.34324Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4188 9.15594L32.0751 6.79594C32.0567 6.66494 32.0349 6.53576 32.0065 6.40869L29.1277 8.96615L29.4188 9.15594Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7924 8.74938L31.8919 5.99579C31.8556 5.88054 31.8157 5.76686 31.7711 5.65527L28.5005 8.56136L28.7924 8.74938Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6697 9.96945L31.9004 8.87572C31.9598 8.68826 32.0071 8.49634 32.0428 8.30127L30.3784 9.78019L30.6697 9.96945Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0444 9.56281L32.1115 7.72633C32.1171 7.63365 32.1203 7.54045 32.1203 7.44619C32.1203 7.38817 32.1177 7.33067 32.1156 7.27344L29.7524 9.37353L30.0444 9.56281Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1835 10.3012C31.3241 10.1051 31.4509 9.90163 31.5622 9.68896L31.0044 10.1846L31.1835 10.3012Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1125 12.7621C22.8048 12.7621 20.1135 10.3714 20.1135 7.43161C20.1135 4.55986 22.683 2.21143 25.8867 2.10645V7.37965H25.89L30.9045 10.635H30.9036C29.8091 11.9256 28.0683 12.7621 26.1125 12.7621Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5647 8.04443H15.2505V9.57484H4.5647V8.04443Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56396 10.4194H12.6681V11.949H4.56396V10.4194Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5647 3.19092H13.4056V4.72132H4.5647V3.19092Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56396 5.56641H12.6681V7.09701H4.56396V5.56641Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.08b50fa6f44643a4207e90623a869faa.svg";
export { ForwardRef as ReactComponent };